module.exports = __webpack_public_path__ + "img/solution.98b2589a.png";